import React, { memo, useMemo } from "react";
import { useAppTheme } from "@/helpers/contexts/themeContext";
import LoginSlider from "./LoginSlider";
import { getImage } from "@/helpers/utils";

const LeftView = () => {
  const { loginData } = useAppTheme() as any;

  const sliderData = useMemo(() => {
    const data = [];
    if (loginData?.image1) {
      data.push({
        image: getImage(loginData?.image1, "LOGIN_CONFIG"),
        title: loginData.text1,
      });
    }

    if (loginData?.image2) {
      data.push({
        image: getImage(loginData.image2, "LOGIN_CONFIG"),
        title: loginData.text2,
      });
    }

    if (loginData?.image3) {
      data.push({
        image: getImage(loginData.image3, "LOGIN_CONFIG"),
        title: loginData.text3,
      });
    }

    if (data.length === 0) {
      const defaultData = [
        {
          image: "/img/login/image1.png",
          title:
            "Engage new customers with geotargeted ads customized for your locations.",
        },
        {
          image: "/img/login/image2.png",
          title:
            "Your campaigns are optimized with advanced AI, and keep you in control.",
        },
        {
          image: "/img/login/image3.png",
          title:
            "Measure results and improve your strategy with actionable results per location.",
        },
      ];
      data.push(...defaultData);
    }

    return data;
  }, [loginData]);

  return (
    <div
      className="auth-left-view w-100 h-100 pt-4 pb-5 pb-md-4"
      style={{ backgroundColor: "var(--neutral-50)" }}
    >
      <LoginSlider data={sliderData} />
    </div>
  );
};

export default memo(LeftView);
